import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "svg-icon-Long",
  "use": "svg-icon-Long-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"svg-icon-Long\"><path d=\"M0 3V.999h16V3H0zm0 8V9h7v2H0zm0 4v-2h7v2H0zm9-4V9h7v2H9zm0 4v-2h7v2H9zM0 7V5h16v2H0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol